import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'src/components/loader';
import { useUserstoryActivities } from 'src/queries/userstory';
import { activityTranslate, activityType } from 'src/constants';
import { Platform } from 'src/types/constants';
import utcToLocal from 'src/utils/utcToLocal';

export default function ActivityPage() {
  // const platform: Platform = JSON.parse(Cookies.get('platform') || '{}');
  const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}")
  const param = useParams();
  const { mutate: getActivities, data } = useUserstoryActivities();

  useEffect(() => {
    getActivities({ id: Number(param.id) });
  }, [getActivities, param.id]);

  if (!data) return <Loader />;

  return (
    <div className="pt-5 pb-5">
      {platform.slug && (
        <div className="my-2 flex flex-row-reverse justify-between">
          <a
            href={`https://eriador.saba-e.com/project/${platform.slug}/us/${param.refid}`}
            target="_blank"
            className="btn btn-primary btn-outline"
            rel="noreferrer"
          >
            لینک به Eriador
          </a>

          <a
            href={`/epics/${param.epicid}`}
            target="_blank"
            className="btn btn-primary btn-outline"
            rel="noreferrer"
          >
            لینک به فیلم
          </a>
        </div>
      )}
      <div className="overflow-auto">
        <table
          className="table w-full"
          style={{ textAlign: 'right' }}
        >
          <thead>
            <tr>
              <th className="bg-blue-100 rounded-none">#</th>
              <th className="bg-blue-100">شرح</th>
              <th className="bg-blue-100">توسط</th>
              <th className="bg-blue-100 rounded-none">نوع</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index: number) => {
              const description = activityType[item.activity_type]
                .replace('__userstoryTitle__', item.user_story_title)
                .replace('__username__', item.creator_username)
                .replace('__taskTitle__', item.task_title ?? '')
                .replace('__oldStatus__', item.old_status ?? '')
                .replace('__newStatus__', item.new_status ?? '');

              console.log('item.created_date', item.created_date);
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <span dangerouslySetInnerHTML={{ __html: description }}></span>
                  </td>
                  <td className="flex flex-col text-left">
                    <span>{item.creator_username}</span>
                    <span dir="ltr">
                      {new Intl.DateTimeFormat('fa-IR-u-nu-latn', {
                        dateStyle: 'short',
                        timeStyle: 'medium',
                        timeZone: 'Asia/Tehran',
                      }).format(utcToLocal(new Date(item.created_date)))}
                    </span>
                  </td>
                  <td>{activityTranslate[item.activity_type]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
